{
  "version": 1,
  "asset_id": "a280193c-bcb3-46ce-b489-54804e9158cc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a280193c-bcb3-46ce-b489-54804e9158cc/scar-tissue-crura-esophagus-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a280193c-bcb3-46ce-b489-54804e9158cc/scar-tissue-crura-esophagus-en-480.webp",
  "original_filename": "scar-tissue-crura-esophagus-en-480.webp",
  "size": 39646,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:56:00Z"
}
